import { TableRow, Theme, Tooltip, Typography } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { Link } from '@material-ui/icons';
import classnames from 'classnames';
import moment from 'moment';
import * as React from 'react';
import MyButton from '../../components/UI/MyButton/index';
import MyTooltip from '../../components/UI/MyTooltip/MyTooltip';
import { IAsset, IFeed } from '../../models/states';
import { LightenDarkenColor } from '../../utilities/utilities';
import {
  Actions,
  AssetId,
  AssetState,
  FeedName,
  MediaType,
  SrNo,
  Status,
  UpdatedAt
} from './Columns';

const styles = (theme: Theme) =>
  createStyles({
    root: { cursor: 'pointer', ...theme.tableRow },
    blackBackground: {
      // background: theme.palette.background.default
    },
    uppercase: {
      textTransform: 'uppercase'
    },
    failedState: {
      backgroundColor: theme.tertiaryColors.red,
      '&:hover': {
        backgroundColor: `${LightenDarkenColor(
          theme.tertiaryColors.red,
          40
        )} !important`
      }
    },
    warning: {
      backgroundColor: theme.tertiaryColors.orange,
      '&:hover': {
        backgroundColor: `${LightenDarkenColor(
          theme.tertiaryColors.orange,
          40
        )} !important`
      }
    },
    escalated: {
      backgroundColor: theme.tertiaryColors.pink,
      '&:hover': {
        backgroundColor: `${LightenDarkenColor(
          theme.tertiaryColors.pink,
          40
        )} !important`
      }
    },
    actionBtn: {
      fontSize: '0.75rem',
      width: '6rem'
    },
    escalateBtn: {
      backgroundColor: '#ffdede',
      color: '#d0021b',
      '&:hover': {
        backgroundColor: '#ffdede',
        color: '#d0021b',
        opacity: 0.8
      }
    },
    resolveBtn: {
      backgroundColor: '#fff',
      color: '#ca7d00',
      '&:hover': {
        backgroundColor: '#fff',
        color: '#ca7d00',
        opacity: 0.8
      }
    },
    escalatedBtn: {
      border: '1px solid white',
      backgroundColor: '#9c333c',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#9c333c !important',
        color: '#fff',
        opacity: 0.8
      }
    },
    assetIdText: {
      maxWidth: '30ch',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 500,
      cursor: 'pointer'
    },
    checkboxRoot: {
      '&$checked': theme.checkbox.yellow
    },
    feedName: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: '30ch'
    },
    checked: {},
    link: {
      textDecoration: 'none',
      display: 'flex',
      marginLeft: '0.5rem',
      color: theme.palette.text.primary
    },
    blur: {
      filter: 'blur(5px)'
    }
  });

class IngestPodTableItem extends React.Component<IIngestPodTableItemProps, {}> {
  render() {
    const { item, index, classes, onEscalate } = this.props;
    const feedNames = item.feeds
      .map((feedCode: string) =>
        this.props.feedMap[`${feedCode}#${item.customer}`]
          ? this.props.feedMap[`${feedCode}#${item.customer}`].name
          : ''
      )
      .join(', ');
    const blur = globalThis.UI_CONFIG.blur_data ? true : false;
    return (
      <TableRow
        key={this.props.key}
        className={classnames(classes.root, {
          [classes.blackBackground]: index % 2,
          [classes.failedState]: item.status.toLowerCase() === 'failed',
          [classes.warning]: item.status.toLowerCase() === 'sla_violated',
          [classes.escalated]: item.issueTrackerId
        })}
        hover
        onClick={e => {
          e.stopPropagation();
          this.props.onOpenAssetSummary();
        }}
      >
        <SrNo>
          <Typography variant="caption">{item.srNo + 1}</Typography>
        </SrNo>
        <AssetId>
          <MyTooltip title={item.assetId} blur={blur}>
            <Typography
              onClick={this.props.onOpenAssetSummary}
              className={classnames(classes.assetIdText, {
                [classes.blur]: blur
              })}
              variant="caption"
            >
              {item.assetId}
            </Typography>
          </MyTooltip>
        </AssetId>
        <AssetState>
          <MyTooltip
            title={
              item.stateErrorMessage
                ? item.stateErrorMessage.length > 300
                  ? item.stateErrorMessage.substring(0, 300)
                  : item.stateErrorMessage
                : item.state
            }
          >
            <Typography className={classes.uppercase} variant="caption">
              {item.state}
            </Typography>
          </MyTooltip>
        </AssetState>
        <UpdatedAt>
          <Typography variant="caption">
            {moment(item.updatedAt).format('YYYY-MM-DD  HH:mm:ss')}
          </Typography>
        </UpdatedAt>
        <FeedName>
          <MyTooltip title={feedNames} blur={blur}>
            <Typography
              variant="caption"
              className={classnames(classes.feedName, { [classes.blur]: blur })}
            >
              {feedNames}
            </Typography>
          </MyTooltip>
        </FeedName>
        <MediaType>
          <Typography className={classes.uppercase} variant="caption">
            {item.mediaType}
          </Typography>
        </MediaType>

        <Status>
          <MyTooltip
            title={
              item.status === 'snoozed'
                ? `Activate at ${moment
                    .unix(item.endSnoozeAt)
                    .format('YYYY-MM-DD HH:mm:ss')}`
                : item.status
            }
          >
            <Typography className={classes.uppercase} variant="caption">
              {item.status}
            </Typography>
          </MyTooltip>
        </Status>
        {globalThis.UI_CONFIG &&
        globalThis.UI_CONFIG.disable_issue_tracker ? null : (
          <Actions>
            <Typography className={classes.uppercase} variant="caption">
              {item.issueTrackerId ? (
                // item.issueTrackerStatus !== 'close' ?
                // (
                <a
                  href={`${globalThis.UI_CONFIG.issue_tracker_url}/${item.issueTrackerId}`}
                  target="_blank"
                  className={classes.link}
                >
                  <Typography>{item.issueTrackerId}</Typography>
                  <Link style={{ paddingBottom: 5 }} />
                </a>
              ) : (
                // )
                //  : (
                //   <a
                //     href={`${globalThis.UI_CONFIG.issue_tracker_url}/${item.issueTrackerId}`}
                //     target="_blank"
                //     className={classes.link}
                //   >
                //     <Typography>{'RESOLVED'}</Typography>
                //   </a>
                // )
                <MyButton
                  className={classnames(classes.actionBtn, classes.escalateBtn)}
                  onClick={e => {
                    e.stopPropagation();
                    onEscalate(item.id);
                  }}
                  btnType={'white'}
                >
                  ESCALATE
                </MyButton>
              )}
            </Typography>
          </Actions>
        )}
      </TableRow>
    );
  }
}
export interface IIngestPodItemOwnProps extends WithStyles<typeof styles> {
  item: IAsset;
  index: number;
  key: number;
  onEscalate: any;
  checked: boolean;
  onToggleSelectedAssets: (assets: string[]) => any;
  onCloseAssetSummary: () => any;
  onOpenAssetSummary: () => any;
  feedMap: { [key: string]: IFeed };
}

type IIngestPodTableItemProps = IIngestPodItemOwnProps;

export default withStyles(styles)(IngestPodTableItem);
